import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=72e47ac5&"
import script from "./Google.vue?vue&type=script&setup=true&lang=js&"
export * from "./Google.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72e47ac5')) {
      api.createRecord('72e47ac5', component.options)
    } else {
      api.reload('72e47ac5', component.options)
    }
    module.hot.accept("./Google.vue?vue&type=template&id=72e47ac5&", function () {
      api.rerender('72e47ac5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/emailChannels/Google.vue"
export default component.exports